<template>
  <div class="schedule-calendar" v-loading="loading">
    <div class="schedule-calendar-left">
      <week :startWeek="startWeek"></week>
      <month :year="year"
             :month="month"
             :startWeek="startWeek"
             :selectDay="selectDay"
             :openState="openState"
             @changeDay="getDay"></month>
    </div>
    <div class="schedule-calendar-right">
      <header class="schedule-calendar-hd">
        <button type="button"
                class="schedule-calendar-arrow left"
                @click="prevMonth">
        </button>
        <div class="schedule-calendar-display">{{year}}年{{(month + 1)>=10?(month + 1):'0'+(month + 1)}}月</div>
        <button type="button"
                class="schedule-calendar-arrow right"
                @click="nextMonth">
        </button>
        <button class="schedule-calendar-hd-changeday-btn" @click="changeToday">
          今天
        </button>
      </header>
      <div class="schedule-calendar-text-wrapper" v-show="openState">
        <span class="schedule-calendar-text-wrapper-day">{{('0'+selectDay.getDate()).substring(('0'+selectDay.getDate()).length-2)}}</span>
        <span class="schedule-calendar-text-wrapper-week">{{computeWeek}}</span>
      </div>
    </div>
    <div class="hint-wrapper">
      <span class="dot finish"></span>
      <span class="hint-text">已结束</span>
      <span class="dot going"></span>
      <span class="hint-text">未开始/正在进行</span>
    </div>
    <button class="open-calendar-btn" @click="changeOpenState">
      <template v-if="openState===false">展开</template>
      <template v-else>收起</template>
    </button>
  </div>
</template>

<script type="text/ecmascript-6">
  import {monthlyCalendar} from './utils'
  import {isSameDay} from './utils'
  import week from './week'
  import month from './month'
  import {calcPrevMonth, calcNextMonth} from './utils'

  export default {
    name: 'schedule-calendar',
    components: {
      week,
      month
    },
    props: {
      startWeek: {
        type: Number,
        default: 0
      },
    },
    data() {
      return {
        year: new Date().getFullYear(),
        month: new Date().getMonth(),
        selectDay: new Date(),     //表示选择的日期
        loading: false,
        openState: false,
      }
    },
    methods: {
      prevMonth() {
        if (this.openState == false) {
          this.openState = true;
          return;
        }
        const {year, month} = calcPrevMonth(this.year, this.month);
        this.year = year;
        this.month = month;
      },
      nextMonth() {
        if (this.openState == false) {
          this.openState = true;
          return;
        }
        const {year, month} = calcNextMonth(this.year, this.month);
        this.year = year;
        this.month = month;
      },
      getDay(e) {
        this.selectDay = e;
        this.$emit('changeDay', e)
      },
      changeToday() {
        this.year = new Date().getFullYear();
        this.month = new Date().getMonth();
        this.selectDay = new Date();
        this.$emit('changeToday');
      },
      changeOpenState() {
        //如果当前没有展开，则展开日历表
        if (this.openState == false) {
          this.openState = true;
        } else {
          //先假设选择的日期没有在当前的月历中，如果遍历数组，发现在月历中，则设置isSameMonth=true
          //此举是为了解决，用户展开日历后，点击上下月，没有选择日期，从而调回到之前选择的日期
          let isSameMonth = false;
          //如果当前选择的日期和日历表同月，则收起，否则跳转至今天再收起
          let daysArray = monthlyCalendar(this.year, this.month, this.startWeek);
          for (let i = 0; i < daysArray.length; i++) {
            if (isSameDay(this.selectDay, daysArray[i].date)) {
              isSameMonth = true;
            }
          }
          if (isSameMonth == false) {
            this.year = this.selectDay.getFullYear();
            this.month = this.selectDay.getMonth()
          }
          this.openState = false;
        }
      }
    },
    computed: {
      computeWeek() {
        let weeks = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
        let weekday = weeks[this.selectDay.getDay()];
        return `${weekday}`
      },
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .schedule-calendar {
    background: #fff;
    overflow: hidden;
    position: relative;
    .schedule-calendar-left {
      float: left;
      overflow: hidden;
      padding: 10px 60px 10px 40px;
      width: 508px;
    }
    .schedule-calendar-right {
      float: right;
      width: 358px;
      height: 100%;
      position: relative;
      .schedule-calendar-hd {
        padding-top: 21px;
        overflow: hidden
        .schedule-calendar-arrow {
          float: left;
          width: 40px;
          height: 24px;
          border: 1px solid #ff6700;
          border-radius: 12px;
          box-sizing: border-box;
          &.left {
            margin-right: 40px;
            background: url("calendarImg/left.png") no-repeat center / 12px
          }
          &.right {
            margin-left: 30px;
            background: url("calendarImg/right.png") no-repeat center / 12px
          }
          &:hover {
            border: none;
            &.left {
              background: #ff6700 url("calendarImg/left-white.png") no-repeat center / 12px
            }
            &.right {
              background: #ff6700 url("calendarImg/right-white.png") no-repeat center / 12px
            }
          }
        }
        .schedule-calendar-display {
          float: left;
          width: 80px;
          font-size: 14px;
          color: #666;
          line-height: 24px;
        }
        .schedule-calendar-hd-changeday-btn {
          float: left;
          margin-left: 30px;
          display: inline-block;
          width: 50px;
          height: 24px;
          line-height: 24px;
          text-align: center
          background: #ff6700;
          font-size: 16px;
          color: #ffffff;
          border-radius: 12px;
          &:hover {
            background: #ff812c
          }
        }
      }
      .schedule-calendar-text-wrapper {
        .schedule-calendar-text-wrapper-day {
          font-size: 100px;
          color: #666666;
          float: left
          margin: 42px 0 0 54px
          height: 132px
          line-height: 132px;
        }
        .schedule-calendar-text-wrapper-week {
          float: left
          margin: 132px 0 0 15px
          font-size: 14px
          color: #666
        }
      }
    }
    .hint-wrapper {
      position: absolute;
      bottom: 21px;
      left: 618px
      .dot {
        margin-right: 4px
        float: left;
        width: 8px;
        height: 8px;
        border-radius: 4px;
        position: relative
        top: 2px
        &.finish {
          background: #ccc;
        }
        &.going {
          background: #ff6700
        }
      }
      .hint-text {
        margin-right: 50px
        float: left;
        font-size: 14px;
        color: #666;
      }
    }
    .open-calendar-btn {
      position: absolute;
      right: 0;
      bottom: 0;
      display: inline-block;
      width: 70px;
      height: 28px;
      line-height: 28px;
      font-size: 14px;
      color: #666;
      border-top: 1px solid #f5f5f5;
      border-left: 1px solid #f5f5f5;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/calendar/calendar.vue